import { api } from '../core';

interface UpdateTimelineEntryCommentResponse {
  success: boolean;
}

interface UpdateTimelineEntryCommentProps {
  abortController?: AbortController;
  entryId: string;
  comment: string;
}

const timelineEntryCommentUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateTimelineEntryComment: builder.query<UpdateTimelineEntryCommentResponse, UpdateTimelineEntryCommentProps>({
      query: ({ abortController = new AbortController(), entryId, comment }: UpdateTimelineEntryCommentProps) => ({
        url: 'timeline/entry/comment/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          comment
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateTimelineEntryComment in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateTimelineEntryCommentQuery } = timelineEntryCommentUpdateApi;
